// Show the size chart popup when the header is clicked
document.querySelector('.size-chart-header').addEventListener('click', function () {
  var sizeChartPopup = document.querySelector('#size-chart-popup');
  if (sizeChartPopup) {
    sizeChartPopup.classList.remove('hidden');
  }
});

// Hide the size chart popup when the close button is clicked
document.querySelector('#size-chart-close').addEventListener('click', function () {
  var sizeChartPopup = document.querySelector('#size-chart-popup');
  if (sizeChartPopup) {
    sizeChartPopup.classList.add('hidden');
  }
});

// Close the popup when Escape or Delete key is pressed
document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape' || event.key === 'Delete') {
    var sizeChartPopup = document.querySelector('#size-chart-popup');
    if (sizeChartPopup && !sizeChartPopup.classList.contains('hidden')) {
      sizeChartPopup.classList.add('hidden');
    }
  }
});

// Function to process range strings like '23.8-24.2'
function processRange(rangeString, factor) {
  const [start, end] = rangeString.split('-');
  const startValue = parseFloat(start);
  const endValue = parseFloat(end);

  if (isNaN(startValue) || isNaN(endValue)) {
    console.error('Invalid range values');
    return rangeString; // Return original range if invalid
  }

  const convertedStart = (startValue * factor).toFixed(1);
  const convertedEnd = (endValue * factor).toFixed(1);

  return `${convertedStart}-${convertedEnd}`;
}

// Convert table values, handling ranges
function convertTableValues(factor, toInches) {
  const rows = document.querySelectorAll('tbody.size-chart-body tr');
  rows.forEach((row) => {
    const cells = row.querySelectorAll('td.convert');
    cells.forEach((cell) => {
      let value = cell.dataset.originalValue;
      if (toInches) {
        if (value.includes('-')) {
          // Process range
          value = processRange(value, factor);
        } else {
          // Convert single value
          value = parseFloat(value);
          if (!isNaN(value)) {
            value = (value * factor).toFixed(1); // Convert to integer
          }
        }
      } else {
        // Revert to original value
        value = cell.dataset.originalValue;
      }
      cell.textContent = value;
    });
  });
}

// Store original values on page load
function storeOriginalValues() {
  const rows = document.querySelectorAll('tbody.size-chart-body tr');
  rows.forEach((row) => {
    const cells = row.querySelectorAll('td.convert');
    cells.forEach((cell) => {
      if (!cell.dataset.originalValue) {
        cell.dataset.originalValue = cell.textContent.trim();
      }
    });
  });
}

// Initialize original values
storeOriginalValues();

// Switch event to handle conversion
document.getElementById('switch').addEventListener('change', function () {
  if (this.checked) {
    convertTableValues(0.393701, true); // Convert to inches
  } else {
    convertTableValues(1, false); // Revert to original values
  }
});